import { MdHome } from 'react-icons/md';

const dashboardnavigation = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: <MdHome size={20} />,
        navLink: '/dashboard',
        action: 'read',
        resource: 'activities',
    },
];

export default dashboardnavigation;
